import screenbanner from "./images/banner/1.jpg";
import mobilebanner from "./images/banner/2.jpg"
import location1 from "./images/blog/News/4.jpg";
import location2 from "./images/blog/News/1.jpg";
import location3 from "./images/blog/News/6.jpg"
import newsShape1 from "./images/shapes/news-one-shape-1.png";
import overviewImage from "./images/blog/6.jpg";


export const Bannerdata = {
  mobilebanner: mobilebanner,
  screenbanner: screenbanner,
};
export const OverviewData = {
  overviewImage: overviewImage,
  buttonLabel: "Enquire Now",
  tagline: "Prestige Group Invests Rs 462 Crore to Acquire 17.45 Acres of Land in Bengaluru",
  description: [
 
      `Prestige Group, a leading name in India’s real estate sector, has acquired a prime 17.45-acre
land parcel in Bengaluru&#39;s Whitefield area for its upcoming residential project. This strategic
acquisition, valued at Rs 462 crore, marks a significant expansion of the group’s presence in the
region.
   `,

 `In its Q2 FY2024-25 results, Prestige Estates Projects Limited reported sales of Rs 40,226
million, with a total sales volume of 3 million square feet in the July-September period. The

company also sold 1,366 units and saw a 4% year-on-year increase in sales collections, which
totaled Rs 27,373 million. During this period, Prestige launched three new residential projects,
including Prestige Raintree Park and Prestige Pine Forest in Bengaluru, and Prestige Forest
Hills in Mumbai.`,

  ],
  amenities: ["High Demand", "Future-Ready Smart Homes"],
  buttonmessage: "More details",
};

// Latest Update
export const LatestUpdate = {
  tagline: `Related Blogs`,
  shape1: newsShape1,
 data: [
    {
      id: 1,
      image: location1,
      alt: "Google",
      date: "01 Jan",
      tag: "Google Leases 5.5 Lakh Sq Ft Office Space in Gurugram, with Plans for Future Expansion",
      title: `Google has secured a significant 550,000 sq ft of office space in Gurugram. `,
      link: "/news-070125",
      review: 2,
    },
    {
      id: 2,
      image: location2,
      alt: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      date: "06 Jan",
      tag: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      title: `TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25 TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25`,
      link: "/news-080125",
      review: 3,
    },
    {
      id: 3,
      image: location3,
      alt: "Prestige Group Invests Rs 462",
      date: "30 Oct",
      tag: "Prestige Group Invests Rs 462 Crore to Acquire 17.45 Acres of Land in Bengaluru",
      title:
      `Prestige Group, a leading name in India’s real estate sector, has acquired a prime 17.45-acre
land parcel in Bengaluru`,
      link: "/news-090125",
      review: 5,
    },
  ],
};
